let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1QSCE")).then(() => parcelRequire('eGaKL'));